import { LocalComponent } from "~/ecs/base"

export class CameraAttached extends LocalComponent {}
